import React from 'react';
import { Modal } from '../../components/ui';
import { fmtDate, fmtTime } from '../../utils/helpers';
import { useFunctionShare } from './useFunctionShare';

// Desktop "share these functions": tick the ceremonies on the left, read the
// message exactly as it will arrive on the right.
export default function ShareFunctionsDesktop(props) {
  const vm = useFunctionShare(props);
  const {
    invitable, picked, toggle, allOn, toggleAll, chosen,
    from, setFrom, message, setMessage, withMap, setWithMap,
    preview, copy, whatsapp, share, canShare, close,
  } = vm;

  return (
    <Modal
      wide dense title="Share functions" onClose={close}
      footer={<>
        <button className="btn light" onClick={close}>Close</button>
        <div className="spacer" style={{ flex: 1 }} />
        {canShare && <button className="btn light" onClick={share}>↗ Share</button>}
        <button className="btn light" onClick={copy}>⧉ Copy</button>
        <button className="btn primary" data-save="primary" disabled={!chosen.length} onClick={whatsapp}>
          Send on WhatsApp
        </button>
      </>}
    >
      <div className="share-fn-layout">
        <div>
          <div className="step-label">
            Which functions
            <button type="button" className="linklike" style={{ marginLeft: 8 }} onClick={toggleAll}>
              {allOn ? 'none' : 'all'}
            </button>
          </div>
          <div className="share-fn-list">
            {invitable.length === 0 && <div className="muted">Every function of this event is over.</div>}
            {invitable.map(f => (
              <label key={f.FunctionId} className={'share-fn-row' + (picked.includes(String(f.FunctionId)) ? ' on' : '')}>
                <input type="checkbox" checked={picked.includes(String(f.FunctionId))} onChange={() => toggle(f.FunctionId)} />
                <span>
                  <strong>{f.FunctionName}</strong>
                  <span className="muted">
                    {' '}· {fmtDate(f.FunctionDate)}
                    {f.StartTime ? ` · ${fmtTime(f.StartTime)}` : ''}
                    {f.Venue ? ` · ${f.Venue}` : ''}
                  </span>
                </span>
              </label>
            ))}
          </div>

          <label className="field">Message on top
            <textarea rows={2} value={message} onChange={e => setMessage(e.target.value)}
              placeholder="With great joy we invite you…" />
          </label>
          <label className="field">From
            <input value={from} onChange={e => setFrom(e.target.value)} placeholder="Ailani Family" />
          </label>
          <label className="share-fn-map">
            <input type="checkbox" checked={withMap} onChange={e => setWithMap(e.target.checked)} />
            Add a map link for each venue
          </label>
        </div>

        <div>
          <div className="step-label">What they receive</div>
          <div className="share-fn-preview">
            {preview.map(line => (
              <div key={line.key} className={line.signature ? 'share-fn-sign' : undefined}>
                {line.parts.map((p, i) => (p.bold ? <strong key={i}>{p.text}</strong> : <span key={i}>{p.text}</span>))}
                {line.parts.length === 0 ? ' ' : null}
              </div>
            ))}
          </div>
        </div>
      </div>
    </Modal>
  );
}
